import idMixin from "@/mixins/forms/id";
import stateMixin from "@/mixins/forms/state";
import disableMixin from "@/mixins/forms/disable";
import focusMixin from "@/mixins/forms/focus";
import sizeMixin from "@/mixins/forms/size";
import variantMixin from "@/mixins/forms/variant";
import tooltipMixin from "@/mixins/forms/tooltip";

export default {
  mixins: [
    idMixin,
    stateMixin,
    disableMixin,
    focusMixin,
    sizeMixin,
    variantMixin,
    tooltipMixin,
  ],
  props: {
    value: {
      type: [String, Number],
      required: false,
      default: null,
    },
    label: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    computedClasses() {
      return {
        ...this.disabledClass,
        ...this.sizeClass,
        ...this.variantClass,
        ...this.focusClass,
        ...this.stateClass,
      };
    },
    computedLabel() {
      return this.label;
    },
  },
};
